import React from "react"

import FieldProto_FormElement from "../../../proto/render/form-element"
import Stepper from "../../../../gd-form/form-element/stepper/stepper"

export default class FieldStepper_FormElement extends FieldProto_FormElement {

    render() {
        const classes: string = Classes("ui5-txt-default h-36 p-l-10 p-r-10 border-box", this.props.className)

        return <Stepper className   =   {classes}
                        form        = {this.props.form}
                        name        = {this.props.field.fieldId}
                        minValue    = {this.props.field.minValue}
                        maxValue    = {this.props.field.maxValue}/>
    }
}